export default class MobileNavigation {
	private state: string;
	private navigationItems: NodeListOf<HTMLAnchorElement>;

	public constructor() {
		this.state = 'closed';
		this.navigationItems = document.querySelectorAll('.header-navigation a');

		const toggles: NodeListOf<HTMLElement> = document.querySelectorAll(
			'.mobile-navigation-toggle'
		);

		toggles.forEach((toggle: HTMLElement) => {
			toggle.addEventListener('click', this.toggleNavigation);
		});

		window.addEventListener('resize', this.updateA11y);
		this.updateA11y();
	}

	private updateA11y = (): void => {
		if (window.innerWidth < 768) {
			this.navigationItems.forEach((item: HTMLAnchorElement) => {
				item.setAttribute('tabindex', '-1');
			});
		} else {
			this.navigationItems.forEach((item: HTMLAnchorElement) => {
				item.removeAttribute('tabindex');
			});
		}
	};

	private toggleNavigation = (): void => {
		switch (this.state) {
			case 'closed':
				document.body.classList.add('mobile-navigation-is-visible');
				this.state = 'open';
				break;
			case 'open':
				document.body.classList.remove('mobile-navigation-is-visible');
				this.state = 'closed';
				break;
		}
	};
}
